/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-12-02 19:29:00
 * Copyright © Leedarson. All rights reserved.
 */
import modalInstance from './modalInstance';
import { EMPTY_FUNCTION } from './constants';
import { noop as NOOP } from '@root/shared';
import Queue from './Queue';

const _queue = new Queue(modalInstance, 'modal');

const _defaultProps = {
  title: '',
  position: 'ios',
  content: '',
  radioLabel: '',
  checked: false,
  confirm: 'Ok',
  cancel: 'Cancel',
  primaryButtons: ['confirm'],
  onChange: EMPTY_FUNCTION,
  onConfirm: EMPTY_FUNCTION,
  onCancel: EMPTY_FUNCTION,
  afterClose: EMPTY_FUNCTION,
};

export default (props = NOOP.EMPTY_OBJECT) => {
  const finalProps = { ..._defaultProps, ...props };
  const { id } = finalProps;
  return _queue.push(id, finalProps);
};

export const pause = () => {
  _queue.pause();
};

export const start = () => {
  _queue.start();
};

export const remove = (id) => {
  _queue.remove(id);
};

export const queue = _queue;
